(function($) {
    const toggles = $('[popup-toggle]')

    toggles.on('click', function() {
        const toggle = $(this)
        const target = toggle.attr('popup-toggle')
        $('body .inner').css({ overflow: 'hidden' })
        $('.popup--' + target).addClass('popup--show')
    })

    $('.popup__overlay, .popup__close').on('click', function() {
        $('body .inner').css({ overflow: 'auto' })
        $(this).closest('.popup--show').toggleClass('popup--show')
    })
})(jQuery)
